import React, { useEffect, useState } from 'react';
import { useWorldStore } from '../stores/worldStore';

const WorldPreloader: React.FC = () => {
  const worldLoading = useWorldStore((s) => s.worldLoading);
  const loadingMessage = useWorldStore((s) => s.loadingMessage);
  const worldName = useWorldStore((s) => s.worldName);
  const [fadeOut, setFadeOut] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [dots, setDots] = useState('');

  // Animate dots
  useEffect(() => {
    if (hidden) return;
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? '' : prev + '.'));
    }, 400);
    return () => clearInterval(interval);
  }, [hidden]);

  // Fade out when loading completes
  useEffect(() => {
    if (!worldLoading && !fadeOut) {
      setFadeOut(true);
      const timer = setTimeout(() => setHidden(true), 800);
      return () => clearTimeout(timer);
    }
  }, [worldLoading, fadeOut]);

  if (hidden) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 99999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0a0e1a 0%, #101828 50%, #0d1117 100%)',
        opacity: fadeOut ? 0 : 1,
        transition: 'opacity 0.8s ease-out',
        pointerEvents: fadeOut ? 'none' : 'auto',
      }}
    >
      {/* Ambient glow */}
      <div
        style={{
          position: 'absolute',
          width: 400,
          height: 400,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(0,194,179,0.08) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />

      {/* Logo / World Name */}
      <div
        style={{
          fontSize: 28,
          fontWeight: 700,
          color: '#e0e6ed',
          letterSpacing: '0.02em',
          marginBottom: 8,
          fontFamily: "'Inter', -apple-system, sans-serif",
        }}
      >
        {worldName || 'GathrXR'}
      </div>

      {/* Loading bar container */}
      <div
        style={{
          width: 240,
          height: 3,
          borderRadius: 2,
          background: 'rgba(255,255,255,0.08)',
          marginTop: 24,
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            height: '100%',
            borderRadius: 2,
            background: 'linear-gradient(90deg, #00c2b3, #00e6d6)',
            animation: 'preloaderBar 2s ease-in-out infinite',
          }}
        />
      </div>

      {/* Status message */}
      <div
        style={{
          marginTop: 16,
          fontSize: 13,
          color: 'rgba(255,255,255,0.45)',
          fontFamily: "'Inter', -apple-system, sans-serif",
          letterSpacing: '0.03em',
          minHeight: 20,
        }}
      >
        {loadingMessage}{dots}
      </div>

      <style>{`
        @keyframes preloaderBar {
          0% { width: 0%; margin-left: 0%; }
          50% { width: 60%; margin-left: 20%; }
          100% { width: 0%; margin-left: 100%; }
        }
      `}</style>
    </div>
  );
};

export default WorldPreloader;
